<template>
  <div
    class="order-action-surface"
    v-if="
      Object.keys(order_detail).length === 0 &&
      order_detail.constructor === Object
    "
  >
    <v-toolbar color="white" dense flat>
      <v-btn
        icon
        @click="getBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <div v-if="loading == true">
        <v-progress-circular
          :size="30"
          :width="5"
          color="primary"
          indeterminate
          class="ma-3"
        ></v-progress-circular
        >Loading...
      </div>
      <div v-else>
        <h1 class="ma-3">error</h1>
      </div>
      <v-spacer />
    </v-toolbar>
  </div>
  <div v-else class="order-action-surface">
    <v-toolbar dense flat dark color="rgba(24, 28, 36, .92)">
      <v-btn
        icon
        @click="backToList()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="order_detail.order_type == 3"
        small
        depressed
        color="blue"
        class="white--text"
        style="border-radius: 10px"
        >Free</v-btn
      >
      <v-toolbar-title
        >Detail order #{{ order_detail.order_code }}</v-toolbar-title
      >
      <v-spacer />
    </v-toolbar>
    <v-card flat class="food-actions-panel">
      <v-card-text class="food-actions-panel__body">
        <div class="food-actions-panel__buttons">
          <v-btn
            round
            color="primary"
            class="black--text food-action-btn"
            @click="dialogToggle"
          >
            <v-icon left small color="black">forum</v-icon>
            <span>Order chat room</span>
          </v-btn>
          <v-btn
            round
            dark
            color="orange"
            class="food-action-btn"
            @click="addTodayStoreSpecialCloseDate()"
            :loading="storeCloseLoading"
            :disabled="
              storeCloseLoading ||
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder ||
              $route.name == 'OrderDetailFood'
            "
          >
            <v-icon left small>store</v-icon>
            <span>ปิดร้านวันนี้</span>
          </v-btn>
          <v-btn
            round
            dark
            color="red"
            class="food-action-btn food-action-btn--danger"
            @click="toCancelOrder()"
            :loading="canceling_order"
            :disabled="
              canceling_order ||
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_detail.order_status == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder ||
              $route.name == 'OrderDetailFood'
            "
          >
            <v-icon left small>cancel</v-icon>
            <span>ยกเลิกออเดอร์</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <order-incentive-dialog
      :order-id="order_detail.order_id"
      :order-code="order_detail.order_code"
      :province="incentiveProvince"
      :order-status="order_detail.order_status"
      :value="order_detail.order_incentive"
      :button="false"
      @saved="$set(order_detail, 'order_incentive', $event)"
    />
    <v-card
      v-if="dispatchTimeline.length > 0 || showDispatchAction"
      class="mt-2 dispatch-timeline-toolbar-card order-section-card"
      flat
    >
      <v-card-text class="py-3">
        <div class="dispatch-timeline-heading">
          <div class="dispatch-timeline-toolbar-title">Dispatch Timeline</div>
          <v-btn
            v-if="showDispatchAction"
            round
            color="primary"
            class="black--text dispatch-retry-glass-btn"
            :loading="dispatchButtonLoading"
            :disabled="dispatchRetryDisabled"
            @click="openDispatchPreview('retry')"
          >
            <v-icon left small color="black">refresh</v-icon>
            <span>{{ dispatchActionLabel }}</span>
          </v-btn>
        </div>
        <div v-if="dispatchStatusText" class="dispatch-status-text">
          {{ dispatchStatusText }}
        </div>
        <div v-if="dispatchCandidateNamesText" class="dispatch-status-subtext">
          {{ dispatchCandidateNamesText }}
        </div>
        <div class="hidden-sm-and-down dispatch-timeline-horizontal">
          <div
            v-for="(step, index) in dispatchTimeline"
            :key="`desktop-${index}`"
            class="dispatch-timeline-horizontal-item dispatch-timeline-step"
            :class="{ 'dispatch-timeline-step-active': step.color !== 'grey' }"
            :style="{ '--dispatch-step-delay': `${index * 90}ms` }"
          >
            <v-icon small :color="step.color">fiber_manual_record</v-icon>
            <span class="dispatch-timeline-horizontal-text">{{
              step.label
            }}</span>
            <div
              v-if="index < dispatchTimeline.length - 1"
              class="dispatch-timeline-horizontal-line"
            ></div>
          </div>
        </div>
        <div class="dispatch-timeline-vertical hidden-md-and-up">
          <div
            v-for="(step, index) in dispatchTimeline"
            :key="`mobile-${index}`"
            class="dispatch-timeline-item dispatch-timeline-step"
            :class="{ 'dispatch-timeline-step-active': step.color !== 'grey' }"
            :style="{ '--dispatch-step-delay': `${index * 90}ms` }"
          >
            <v-icon small :color="step.color">fiber_manual_record</v-icon>
            <span class="dispatch-timeline-text">{{ step.label }}</span>
            <div
              v-if="index < dispatchTimeline.length - 1"
              class="dispatch-timeline-line"
            ></div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-2 order-section-card">
      <v-layout row wrap>
        <v-flex sm6 xs12>
          <v-card-text>
            <transferInformation
              :order_time="order_time"
              :order_date="order_date"
              :order_end_time="order_end_time"
              :order_end_date="order_end_date"
              :transfer_time="transfer_time"
              :transfer_date="transfer_date"
              :order_detail="order_detail"
              @viewIMG="viewImage($event)"
              @setOrderDate="order_date = $event"
              @setOrderTime="order_time = $event"
              @cloneOrder="cloneOrder()"
            />
          </v-card-text>
        </v-flex>
        <v-flex sm6 xs12>
          <v-card-text>
            <customer-information
              @fetchAddress="fetchAddress()"
              :loading="loading"
              :statusBtn="statusBtn"
              :order_detail="order_detail"
              @viewIMG="viewImage($event)"
            />
          </v-card-text>
          <v-card-text>
            <OrderDirectionMap
              :directionRoute="directionRoute"
              :storePosition="storePosition"
              :customerPosition="customerPosition"
              :order_detail="order_detail"
            />
          </v-card-text>
          <v-card-text>
            <chatlog
              :statusBtn="statusBtn"
              :openDialogChat="openDialogChat"
              :order_detail="order_detail"
              :provinceData="provinceData"
              @toggleDialogChat="toggleDialogChat"
            />
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-layout column>
          <v-flex>
            <v-btn
              block
              round
              color="primary"
              class="black--text"
              :disabled="
                update_btn ||
                update_loading == 1 ||
                isEditOrder ||
                order_detail.order_status == 7
              "
              @click="updateData()"
              >UPDATE</v-btn
            >
          </v-flex>
          <v-flex>
            <div transition="fade">
              <v-icon color="green" v-if="update_loading == 2">check</v-icon>
              <v-icon color="red" v-if="update_loading == 3">close</v-icon>
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="grey"
                v-if="update_loading == 1"
              ></v-progress-circular>
              {{
                update_loading == 1
                  ? "Updating"
                  : update_loading == 2
                  ? "Update successfully"
                  : update_loading == 3
                  ? "Cant update"
                  : null
              }}
            </div>
          </v-flex>
        </v-layout>
        <v-spacer />
      </v-card-actions>
      <v-divider />
    </v-card>
    <v-card flat class="pb-3 order-section-card">
      <orderDetailProductList @cloneOrder="cloneOrder()" />
    </v-card>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class="mt-3 order-section-card">
          <v-card-text>
            <rider-information
              :isDisableRider="isDisableRider"
              @cloneOrder="cloneOrder()"
              :order_detail="order_detail"
              :header-action-layout="true"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <orderLog class="mt-3" :order_detail="order_detail" />
    <imageDialog
      :place_name="place_name"
      :view_img_position="view_img_position"
      :dialog="imageDialog"
      @dialog="imageDialog = $event"
    />
    <dispatch-candidate-dialog
      :dialog="dispatchPreviewDialog"
      :preview="dispatchPreviewData"
      :loading="dispatchPreviewLoading"
      :confirmLoading="dispatchLoading"
      :mode="dispatchPreviewMode"
      @dialog="dispatchPreviewDialog = $event"
      @confirm="confirmDispatchPreview"
    />
    <v-dialog v-model="cancelDialog" persistent max-width="300px">
      <v-card
        ><v-card-title style="background-color: #212121"
          ><h3 style="color: white">Why do you want to cancel ?</h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              cancelDialog = false;
              cancelRemark = '';
            "
          >
            <v-icon color="white">close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCancel">
            <v-text-field
              label="Reason"
              v-model="cancelRemark"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  v.replace(/\ /g, '').replace(/\-/g, '') != '' ||
                  'No symbol only',
              ]"
            ></v-text-field></v-form
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" style="color: #212121" @click="cancelOrder()"
            >submit</v-btn
          ></v-card-actions
        ></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import chatlog from "../OrderOnline/OrderDetail/Chat";
import customerInformation from "./OrderDetail/CustomerInformation.vue";
import riderInformation from "./OrderDetail/RiderInformation.vue";
import orderLog from "./OrderDetail/OrderLog.vue";
import transferInformation from "./OrderDetail/TransferInformation.vue";
import orderDetailProductList from "./OrderDetailProductList";
import OrderIncentiveDialog from "./OrderIncentiveDialog.vue";
import filterCustomerForm from "./FilterCustomerForm";
import imageDialog from "./ImageDialog";
import GoogleMap from "@/components/Plugins/GoogleMap.vue";
import OrderDirectionMap from "./OrderDirectionMap.vue";
import DispatchCandidateDialog from "./DispatchCandidateDialog.vue";
import realtimeDispatchSocket from "@/services/realtimeDispatchSocket";
import appConfigFeatureService from "@/services/appConfigFeatureService";
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  props: ["order_id"],
  components: {
    OrderIncentiveDialog,
    chatlog,
    customerInformation,
    riderInformation,
    orderLog,
    transferInformation,
    orderDetailProductList,
    filterCustomerForm,
    imageDialog,
    GoogleMap,
    OrderDirectionMap,
    DispatchCandidateDialog,
  },
  data() {
    return {
      statusBtn: "",
      openDialogChat: false,
      original_data: {},
      canceling_order: false,
      update_loading: 0,
      loading: false,
      original_transfer_time: [],
      original_transfer_date: [],
      transfer_time: [],
      transfer_date: [],
      original_order_time: {},
      original_order_date: {},
      order_time: { value: { HH: "", mm: "" } },
      order_date: { value: null },
      original_order_end_time: {},
      original_order_end_date: {},
      order_end_time: { value: { HH: "", mm: "" } },
      order_end_date: { value: null },
      place_name: null,
      view_img_position: null,
      place: 2,
      imageDialog: false,
      filterDialog: false,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      transfer_note: "",
      order_note: "",
      update_btn_disable: true,
      timeOutEnableRider: 0,
      isDisableRider: true,
      cancelRemark: "",
      cancelDialog: false,
      directionRoute: [],
      storePosition: null,
      customerPosition: null,
      storeCloseLoading: false,
      dispatchLoading: false,
      dispatchOfferLoading: false,
      dispatchPreviewDialog: false,
      dispatchPreviewLoading: false,
      dispatchPreviewData: null,
      dispatchPreviewRequest: null,
      dispatchPreviewMode: "request",
      dispatchSocket: null,
      dispatchSocketState: "connecting",
      dispatchReconnectTimer: null,
      dispatchHeartbeatTimer: null,
      dispatchStatusPollTimer: null,
      liveDispatchStatus: null,
    };
  },
  computed: {
    incentiveProvince() {
      return String(
        this.$route.params.province ||
          this.$store.state.backOffice.province ||
          ""
      )
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    },
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
      order_detail: (state) => state.fetchOrderDetailBack.order_detail,
      sub_district_list: (state) => state.fetchProvinceBack.sub_district_list,
      order_count_old: (state) => state.fetchOrderListBack.order_count_old,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    isAutoDispatchFeatureEnabled() {
      return appConfigFeatureService.isFeatureEnabled(
        "auto_dispatch_order_system",
        {
          defaultValue: true,
        }
      );
    },
    update_btn() {
      this.update_btn_disable = this.unSavedData();
      return this.update_btn_disable;
    },
    dispatchActionLabel() {
      if (this.dispatchSocketState !== "connected") {
        return "Connecting";
      }
      return "Retry Dispatch";
    },
    dispatchButtonLoading() {
      return (
        this.dispatchOfferLoading ||
        this.dispatchPreviewLoading ||
        this.dispatchLoading
      );
    },
    hasAssignedRider() {
      return Boolean(
        this.order_detail?.order_rider_id ||
          this.order_detail?.order_rider_full_name
      );
    },
    isDispatchReady() {
      return (
        String(this.order_detail?.order_dispatch_state || "").toUpperCase() ===
        "READY_FOR_DISPATCH"
      );
    },
    dispatchLifecycleStatus() {
      if (this.hasAssignedRider) {
        return "assigned";
      }
      const liveStatus = String(
        this.liveDispatchStatus?.dispatchStatus ||
          this.liveDispatchStatus?.status ||
          ""
      )
        .toLowerCase()
        .trim();
      if (
        liveStatus === "dispatching" ||
        liveStatus === "assigned" ||
        liveStatus === "failed"
      ) {
        return liveStatus;
      }
      const storedStatus = String(this.order_detail?.dispatch_status || "")
        .toLowerCase()
        .trim();
      if (
        storedStatus === "dispatching" ||
        storedStatus === "assigned" ||
        storedStatus === "failed"
      ) {
        return storedStatus;
      }
      if (this.isDispatchReady) {
        return "idle";
      }
      return null;
    },
    canRetryDispatch() {
      return this.dispatchLifecycleStatus === "failed";
    },
    dispatchRetryDisabled() {
      return (
        this.dispatchButtonLoading ||
        this.dispatchSocketState !== "connected" ||
        this.isEditOrder ||
        !this.canRetryDispatch
      );
    },
    showDispatchAction() {
      return (
        this.isAutoDispatchFeatureEnabled &&
        !this.hasAssignedRider &&
        this.isDispatchReady &&
        this.dispatchLifecycleStatus !== "assigned"
      );
    },
    dispatchStatusText() {
      if (
        !this.isDispatchReady &&
        !this.liveDispatchStatus &&
        !this.hasAssignedRider
      ) {
        return "";
      }
      if (this.dispatchLifecycleStatus === "dispatching") {
        const riderName =
          this.liveDispatchStatus?.currentRiderName ||
          this.liveDispatchStatus?.currentRiderId ||
          "";
        return riderName
          ? `Dispatching... offering to ${riderName}`
          : "Dispatching...";
      }
      if (this.dispatchLifecycleStatus === "failed") {
        return "Failed (retry available)";
      }
      if (this.dispatchLifecycleStatus === "assigned") {
        return "Rider assigned";
      }
      if (this.isDispatchReady) {
        return "Waiting for rider";
      }
      return "";
    },
    dispatchCandidateNamesText() {
      const candidateNames = Array.isArray(
        this.liveDispatchStatus?.candidateRiderNames
      )
        ? this.liveDispatchStatus.candidateRiderNames
            .map((value) => String(value || "").trim())
            .filter(Boolean)
        : [];
      if (!candidateNames.length) {
        return "";
      }
      return `Candidates: ${candidateNames.join(", ")}`;
    },
    dispatchTimeline() {
      if (!this.isAutoDispatchFeatureEnabled) {
        return [];
      }
      if (this.liveDispatchStatus) {
        return this.buildDispatchTimelineFromStatus(this.liveDispatchStatus);
      }
      if (this.hasAssignedRider) {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: "Rider Assigned", color: "#fddf00" },
        ];
      }
      if (this.dispatchSocketState !== "connected") {
        return this.buildDispatchConnectionTimeline();
      }
      const state = this.getDispatchState(this.order_detail);
      if (!state) return [];
      const highlight = "#fddf00";
      const base = ["Dispatch Started", "Offering Rider"];
      if (state === "offering") {
        return base.map((label, index) => ({
          label,
          color: index === 1 ? highlight : "grey",
        }));
      }
      if (state === "assigned") {
        const items = [...base, "Rider Accepted"];
        return items.map((label, index) => ({
          label,
          color: index === 2 ? highlight : "grey",
        }));
      }
      if (state === "open_list") {
        const items = [...base, "Open List"];
        return items.map((label, index) => ({
          label,
          color: index === 2 ? highlight : "grey",
        }));
      }
      if (state === "manual") {
        const items = ["Dispatch Started", "Manual Dispatch", "Rider Assigned"];
        return items.map((label, index) => ({
          label,
          color: index === 1 ? highlight : "grey",
        }));
      }
      if (state === "ready_for_dispatch" || this.isDispatchReady) {
        return [
          { label: "Ready For Dispatch", color: "grey" },
          { label: "Waiting For Rider", color: highlight },
        ];
      }
      return [];
    },
    timeToEnableRider() {
      var date1 = new Date();
      var date2 = new Date(this.order_detail.order_time_start);
      var diff = 10 * 1000 + 2 * 60 * 1000 + date2.getTime() - date1.getTime();
      var msec = diff;
      var hh = Math.floor(msec / 1000 / 60 / 60);
      msec -= hh * 1000 * 60 * 60;
      var mm = Math.floor(msec / 1000 / 60);
      msec -= mm * 1000 * 60;
      var ss = Math.floor(msec / 1000);
      msec -= ss * 1000;
      return hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000 > 0
        ? hh * 1000 * 60 * 60 + mm * 1000 * 60 + ss * 1000
        : 0;
    },
  },
  watch: {
    order_detail() {
      if (
        Object.keys(this.order_detail).length != 0 &&
        this.order_detail.constructor === Object
      ) {
        this.setTime();
      }
      clearTimeout(this.timeOutEnableRider);
      let vm = this;
      this.isDisableRider = true;
      this.timeOutEnableRider = setTimeout(function () {
        vm.isDisableRider = false;
      }, this.timeToEnableRider);
    },
  },
  methods: {
    getDispatchState(item) {
      if (!item) return null;
      if (item.order_rider_id || item.order_rider_full_name) {
        return "assigned";
      }
      const raw =
        item.dispatch_state ||
        item.order_dispatch_state ||
        item.dispatchState ||
        item.dispatch_status ||
        item.dispatch_status_id;
      if (raw == null) return null;
      const normalized = String(raw).toLowerCase().trim();
      if (normalized === "ready_for_dispatch") {
        return "ready_for_dispatch";
      }
      if (
        normalized === "searching" ||
        normalized === "offering" ||
        normalized === "offering_rider"
      ) {
        return "offering";
      }
      if (normalized === "assigned") return "assigned";
      if (
        normalized === "broadcast" ||
        normalized === "open_list" ||
        normalized === "openlist"
      ) {
        return "open_list";
      }
      if (normalized === "manual") return "manual";
      return normalized;
    },
    resolveDispatchOrderId() {
      return String(
        this.order_detail?.order_code ||
          this.order_detail?.order_id ||
          this.order_id ||
          ""
      ).trim();
    },
    getDispatchGatewayBase() {
      return String(process.env.VUE_APP_REALTIME_GATEWAY_URL || "").trim();
    },
    getCoreBackendBase() {
      return String(process.env.VUE_APP_BACKEND_URL || "").trim();
    },
    getCoreBackendApiVersion() {
      return String(process.env.VUE_APP_BACKEND_API_VERSION || "").trim();
    },
    resolveProvinceRouteZoneId() {
      const routeProvince = String(this.$route.params.province || "").trim();
      if (!routeProvince || !Array.isArray(this.provinceData)) {
        return "";
      }

      const normalizeProvinceValue = (value) =>
        String(value || "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/-/g, "");

      const normalizedRouteProvince = normalizeProvinceValue(routeProvince);
      const matchedProvince = this.provinceData.find((province) => {
        const provinceId = String(province?.province_id || "").trim();
        const provinceNameEn = normalizeProvinceValue(
          province?.province_name_en
        );

        return (
          provinceId === routeProvince ||
          provinceNameEn === normalizedRouteProvince
        );
      });

      return matchedProvince ? String(matchedProvince.province_id).trim() : "";
    },
    formatDispatchAddress(...values) {
      const normalized = values
        .map((value) => String(value || "").trim())
        .filter(Boolean);
      return normalized[0] || "";
    },
    getDispatchOfferDetailsUrl(orderCode) {
      const backendBase = this.getCoreBackendBase();
      const apiVersion = this.getCoreBackendApiVersion();
      const routeProvince = String(this.$route.params.province || "").trim();
      const normalizedOrderCode = String(orderCode || "").trim();

      if (!backendBase) {
        throw new Error("VUE_APP_BACKEND_URL is not configured.");
      }
      if (!apiVersion) {
        throw new Error("VUE_APP_BACKEND_API_VERSION is not configured.");
      }
      if (!routeProvince || !normalizedOrderCode) {
        throw new Error("Order province or order code is missing.");
      }

      return `${backendBase}/api/v${apiVersion}/${routeProvince}/dispatch/order_offer/${encodeURIComponent(
        normalizedOrderCode
      )}`;
    },
    normalizeDispatchOfferResponse(baseRequest, payload) {
      const data = payload?.data || {};
      const merchant = data?.merchant || {};
      const fallbackMerchant = baseRequest?.merchant || {};
      const fallbackDetails = baseRequest?.offerDetails || {};
      const lat = Number(merchant?.lat);
      const lng = Number(merchant?.lng);
      const zoneId = String(
        merchant?.zoneId ?? fallbackMerchant?.zoneId ?? ""
      ).trim();
      const transferPrice =
        data?.orders_transfer_price ??
        fallbackDetails?.ordersTransferPrice ??
        fallbackDetails?.deliveryFee ??
        null;
      const payAtStore =
        data?.pay_at_store ??
        fallbackDetails?.payAtStore ??
        fallbackDetails?.payAtStoreAmount ??
        null;

      return {
        ...baseRequest,
        merchant: {
          lat: Number.isFinite(lat) ? lat : fallbackMerchant?.lat,
          lng: Number.isFinite(lng) ? lng : fallbackMerchant?.lng,
          zoneId,
        },
        offerDetails: {
          ...fallbackDetails,
          ordersId:
            data?.orders_id ??
            fallbackDetails?.ordersId ??
            this.order_detail?.orders_id ??
            this.order_detail?.order_id ??
            null,
          orderCode: String(
            data?.order_code ||
              fallbackDetails?.orderCode ||
              baseRequest?.orderId ||
              ""
          ).trim(),
          orderType: String(
            data?.order_type || fallbackDetails?.orderType || "food"
          ).trim(),
          restaurantName: this.formatDispatchAddress(
            data?.restaurant_name,
            fallbackDetails?.restaurantName
          ),
          startPoint: this.formatDispatchAddress(
            data?.start_point,
            fallbackDetails?.startPoint
          ),
          endPoint: this.formatDispatchAddress(
            data?.end_point,
            fallbackDetails?.endPoint
          ),
          deliveryFee: transferPrice,
          ordersTransferPrice: transferPrice,
          payAtStoreAmount: payAtStore,
          payAtStore,
          pointCount:
            Number(data?.point_count) > 0
              ? Number(data.point_count)
              : fallbackDetails?.pointCount || 2,
        },
      };
    },
    async prepareDispatchRequest() {
      const baseRequest = this.buildDispatchRequest();
      const url = this.getDispatchOfferDetailsUrl(baseRequest.orderId);
      this.dispatchOfferLoading = true;
      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: localStorage.getItem("token") || "",
          },
        });
        const payload = await res.json().catch(() => ({}));

        if (!res.ok || payload?.msg !== true || !payload?.data) {
          throw new Error(payload?.error || "dispatch_offer_details_failed");
        }

        return this.normalizeDispatchOfferResponse(baseRequest, payload);
      } finally {
        this.dispatchOfferLoading = false;
      }
    },
    getDispatchAuthorizationHeader() {
      const token = String(localStorage.getItem("token") || "").trim();
      if (!token) return "";
      return token.toLowerCase().startsWith("bearer ")
        ? token
        : `Bearer ${token}`;
    },
    getDispatchErrorMessage(errorCode, fallbackMessage) {
      const normalized = String(errorCode || "")
        .trim()
        .toLowerCase();
      if (normalized === "unauthorized") {
        return "Your session is invalid or expired. Please sign in again.";
      }
      if (
        normalized === "verify_failed" ||
        normalized === "verify_url_missing"
      ) {
        return "Dispatch auth service is unavailable right now. Please try again.";
      }
      if (normalized === "forbidden") {
        return "This action is not allowed for the current account.";
      }
      return fallbackMessage;
    },
    getDispatchWebSocketUrl() {
      const gatewayBase = this.getDispatchGatewayBase();
      if (!gatewayBase) return "";
      try {
        const parsed = new URL(gatewayBase);
        parsed.protocol = parsed.protocol === "https:" ? "wss:" : "ws:";
        parsed.pathname = "/ws";
        parsed.search = "";
        parsed.hash = "";
        return parsed.toString();
      } catch (error) {
        return "";
      }
    },
    buildDispatchTimelineFromStatus(statusPayload) {
      const status = String(
        statusPayload?.phase ||
          statusPayload?.state ||
          statusPayload?.status ||
          ""
      ).toUpperCase();
      const radius = Number(statusPayload?.radius || 0);
      const attempt = Number(statusPayload?.attempt || 0);
      const checkedRiders = Number(statusPayload?.checkedRiders || 0);
      const candidateRiderNames = Array.isArray(
        statusPayload?.candidateRiderNames
      )
        ? statusPayload.candidateRiderNames
            .map((value) => String(value || "").trim())
            .filter(Boolean)
        : [];
      const currentRiderName = String(
        statusPayload?.currentRiderName || statusPayload?.currentRiderId || ""
      ).trim();
      const candidateSummary =
        candidateRiderNames.length > 0
          ? `Candidates: ${candidateRiderNames.slice(0, 3).join(", ")}${
              candidateRiderNames.length > 3
                ? ` +${candidateRiderNames.length - 3} more`
                : ""
            }`
          : null;
      const detail = [
        attempt > 0 ? `Attempt ${attempt}` : null,
        radius > 0 ? `${radius} km` : null,
        Number.isFinite(checkedRiders)
          ? `${checkedRiders} riders checked`
          : null,
        currentRiderName ? `Offering to ${currentRiderName}` : null,
        candidateSummary,
      ]
        .filter(Boolean)
        .join(" • ");

      const withDetail = (label) => (detail ? `${label} (${detail})` : label);
      const highlight = "#fddf00";
      const warning = "#fb8c00";
      const danger = "#e53935";

      if (status === "SEARCHING") {
        return [{ label: withDetail("Searching Riders"), color: highlight }];
      }
      if (status === "OFFERING") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: withDetail("Offering Rider"), color: highlight },
        ];
      }
      if (status === "ASSIGNED") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: withDetail("Rider Assigned"), color: highlight },
        ];
      }
      if (status === "BROADCAST") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: "Offering Rider", color: "grey" },
          { label: withDetail("Broadcast To Order List"), color: warning },
        ];
      }
      if (status === "FAILED") {
        return [
          { label: "Dispatch Started", color: "grey" },
          { label: withDetail("No Rider Accepted"), color: danger },
        ];
      }
      return [];
    },
    buildDispatchConnectionTimeline() {
      const danger = "#e53935";
      const info = "#1e88e5";
      if (this.dispatchSocketState === "failed") {
        return [
          {
            label: "Dispatch Connection Failed",
            color: danger,
          },
        ];
      }
      if (this.dispatchSocketState === "connecting") {
        return [
          {
            label: "Dispatch Connecting",
            color: info,
          },
        ];
      }
      return [];
    },
    applyDispatchStatus(payload) {
      if (!payload) return;
      const currentOrderId = this.resolveDispatchOrderId();
      if (!currentOrderId || String(payload.orderId || "") !== currentOrderId) {
        return;
      }
      this.liveDispatchStatus = {
        orderId: currentOrderId,
        status: payload.status,
        dispatchStatus:
          payload.dispatchStatus ||
          (["SEARCHING", "OFFERING"].includes(
            String(payload.status || "").toUpperCase()
          )
            ? "dispatching"
            : String(payload.status || "").toUpperCase() === "BROADCAST"
            ? "failed"
            : payload.status),
        phase: payload.phase || payload.state || payload.status,
        radius: payload.radius,
        attempt: payload.attempt,
        checkedRiders: payload.checkedRiders,
        assignedRiderId: payload.assignedRiderId || null,
        failureReason: payload.failureReason || null,
        currentRiderId: payload.currentRiderId || null,
        currentRiderName: payload.currentRiderName || null,
        candidateRiderIds: Array.isArray(payload.candidateRiderIds)
          ? payload.candidateRiderIds
          : [],
        candidateRiderNames: Array.isArray(payload.candidateRiderNames)
          ? payload.candidateRiderNames
          : [],
      };
      this.$store.commit("fetchOrderListBack/updateDispatchStatus", payload);
    },
    applyOptimisticRetryState() {
      const orderId = this.resolveDispatchOrderId();
      if (!orderId) {
        return;
      }

      const previewAttempts = Array.isArray(this.dispatchPreviewData?.attempts)
        ? this.dispatchPreviewData.attempts
        : [];
      const firstAttempt =
        previewAttempts.find(
          (attempt) =>
            Array.isArray(attempt?.candidates) && attempt.candidates.length > 0
        ) ||
        previewAttempts[0] ||
        null;
      const candidateRiderNames = Array.isArray(firstAttempt?.candidates)
        ? firstAttempt.candidates
            .map((candidate) =>
              String(candidate?.riderName || candidate?.riderId || "").trim()
            )
            .filter(Boolean)
        : [];
      const candidateRiderIds = Array.isArray(firstAttempt?.candidates)
        ? firstAttempt.candidates
            .map((candidate) => String(candidate?.riderId || "").trim())
            .filter(Boolean)
        : [];

      this.applyDispatchStatus({
        orderId,
        status: "dispatching",
        dispatchStatus: "dispatching",
        phase: "OFFERING",
        attempt: Number(firstAttempt?.attempt || 1),
        radius: Number(firstAttempt?.radius || 0),
        checkedRiders: Number(
          firstAttempt?.checkedRiders || candidateRiderIds.length || 0
        ),
        currentRiderId: candidateRiderIds[0] || null,
        currentRiderName: candidateRiderNames[0] || null,
        candidateRiderIds,
        candidateRiderNames,
        failureReason: null,
      });
    },
    startDispatchStatusPolling() {
      this.stopDispatchStatusPolling();
      this.dispatchStatusPollTimer = setInterval(() => {
        this.hydrateDispatchStatus();
      }, 5000);
    },
    stopDispatchStatusPolling() {
      clearInterval(this.dispatchStatusPollTimer);
      this.dispatchStatusPollTimer = null;
    },
    scheduleDispatchReconnect() {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = setTimeout(() => {
        this.connectDispatchSocket();
      }, 3000);
    },
    startDispatchHeartbeat(socket) {
      this.stopDispatchHeartbeat();
      this.dispatchHeartbeatTimer = setInterval(() => {
        if (
          socket &&
          socket === this.dispatchSocket &&
          socket.readyState === WebSocket.OPEN
        ) {
          try {
            socket.send("ping");
          } catch (error) {
            // no-op
          }
        }
      }, 25000);
    },
    stopDispatchHeartbeat() {
      clearInterval(this.dispatchHeartbeatTimer);
      this.dispatchHeartbeatTimer = null;
    },
    async hydrateDispatchStatus() {
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !token || !orderId) {
        return;
      }

      try {
        const res = await fetch(`${gatewayBase}/dispatch/status/bulk`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ orderIds: [orderId] }),
        });
        const data = await res.json();
        const payload = Array.isArray(data?.statuses) ? data.statuses[0] : null;
        if (!res.ok || !data?.ok || (!payload?.status && !payload?.phase)) {
          return;
        }
        this.applyDispatchStatus(payload);
      } catch (error) {
        // no-op
      }
    },
    connectDispatchSocket() {
      if (!this.isAutoDispatchFeatureEnabled) {
        this.disconnectDispatchSocket(false);
        this.dispatchSocketState = "disabled";
        return;
      }
      const gatewayBase = this.getDispatchGatewayBase();
      const token = localStorage.getItem("token") || "";
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !token || !orderId) {
        this.dispatchSocketState = "failed";
        return;
      }

      if (!this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription = realtimeDispatchSocket.subscribe({
          onStateChange: (state) => {
            this.dispatchSocketState = state;
            if (state === "connected") {
              this.syncDispatchSubscriptions();
              this.hydrateDispatchStatus();
            }
          },
          onDispatchStatus: (payload) => {
            this.applyDispatchStatus(payload);
          },
        });
      }

      realtimeDispatchSocket.ensureConnection({
        gatewayBase,
        token,
      });
      this.syncDispatchSubscriptions();
    },
    disconnectDispatchSocket(allowClose = true) {
      clearTimeout(this.dispatchReconnectTimer);
      this.dispatchReconnectTimer = null;
      this.stopDispatchStatusPolling();
      if (this.dispatchSocketSubscription) {
        this.dispatchSocketSubscription.dispose();
        this.dispatchSocketSubscription = null;
      }
      if (allowClose) {
        this.dispatchSocketState = "connecting";
      }
    },
    syncDispatchSubscriptions() {
      if (!this.dispatchSocketSubscription) {
        return;
      }
      const orderId = this.resolveDispatchOrderId();
      this.dispatchSocketSubscription.updateOrderIds(orderId ? [orderId] : []);
    },
    toggleDialogChat(value) {
      this.openDialogChat = !value;
    },
    dialogToggle() {
      this.openDialogChat = !this.openDialogChat;
      this.statusBtn = "order_detail";
    },
    buildDispatchRequest() {
      const firstPosition = Array.isArray(this.order_detail?.order_position)
        ? this.order_detail.order_position[0] || {}
        : {};
      const store = Array.isArray(this.order_detail?.order_store)
        ? this.order_detail.order_store[0] || {}
        : this.order_detail?.order_store || {};
      const orderId = String(
        this.order_detail?.order_code ||
          this.order_detail?.order_id ||
          this.order_id ||
          ""
      ).trim();
      const lat = Number(
        firstPosition.position_lat ||
          firstPosition.store_lat ||
          firstPosition.store_latitude ||
          store.store_lat ||
          store.store_latitude ||
          this.order_detail?.store_lat ||
          this.order_detail?.store_latitude
      );
      const lng = Number(
        firstPosition.position_long ||
          firstPosition.position_lng ||
          firstPosition.store_long ||
          firstPosition.store_lng ||
          firstPosition.store_longitude ||
          store.store_long ||
          store.store_lng ||
          store.store_longitude ||
          this.order_detail?.store_long ||
          this.order_detail?.store_lng ||
          this.order_detail?.store_longitude
      );
      const zoneId = String(
        this.order_detail?.order_zone_id ||
          this.order_detail?.zone_id ||
          this.order_detail?.province_id ||
          this.order_detail?.order_province_id ||
          this.order_detail?.order_customer_address
            ?.customer_address_province_id ||
          this.resolveProvinceRouteZoneId() ||
          this.$route.params.province ||
          this.order_detail?.order_districts_name ||
          this.order_detail?.order_districts_id ||
          ""
      ).trim();

      if (
        !orderId ||
        !zoneId ||
        !Number.isFinite(lat) ||
        !Number.isFinite(lng)
      ) {
        throw new Error(
          "Order is missing merchant latitude, longitude, or zone."
        );
      }

      const gatewayBase = String(
        process.env.VUE_APP_REALTIME_GATEWAY_URL || ""
      ).trim();

      if (!gatewayBase) {
        throw new Error("VUE_APP_REALTIME_GATEWAY_URL is not configured.");
      }

      const customerAddress = this.formatDispatchAddress(
        this.order_detail?.order_customer_address?.customer_address_full,
        this.order_detail?.order_customer_address?.customer_address_name,
        this.order_detail?.order_customer_address?.customer_address_detail,
        this.order_detail?.order_customer_address?.customer_address_address,
        this.order_detail?.order_customer_address?.customer_address_text
      );
      const restaurantName = this.formatDispatchAddress(
        store.store_name,
        store.store_name_en,
        firstPosition.position_name,
        firstPosition.order_point_address,
        `Order #${orderId}`
      );
      const startPoint = this.formatDispatchAddress(
        firstPosition.order_point_address,
        firstPosition.position_name,
        store.store_name,
        restaurantName
      );
      const endPoint = customerAddress || "ลูกค้าปลายทาง";
      const deliveryFee =
        this.order_detail?.order_transfer_price ??
        this.order_detail?.order_delivery_price ??
        this.order_detail?.orders_transfer_price ??
        this.order_detail?.order_delivery_fee ??
        this.order_detail?.delivery_fee ??
        this.order_detail?.delivery_price ??
        this.order_detail?.order_shipping_price ??
        null;
      const payAtStoreAmount = this.order_detail?.pay_at_store ?? null;

      return {
        orderId,
        gatewayBase,
        merchant: { lat, lng, zoneId },
        offerDetails: {
          ordersId:
            this.order_detail?.orders_id ?? this.order_detail?.order_id ?? null,
          orderCode: orderId,
          orderType:
            Number(this.order_detail?.order_type) === 2 ? "messenger" : "food",
          restaurantName,
          startPoint,
          endPoint,
          deliveryFee,
          ordersTransferPrice: deliveryFee,
          payAtStoreAmount,
          payAtStore: payAtStoreAmount,
          pointCount: 2,
        },
      };
    },
    async openDispatchPreview(mode = "request") {
      let request = null;
      try {
        request = await this.prepareDispatchRequest();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Dispatch data missing",
          text: error?.message || "Unable to prepare dispatch preview.",
        });
        return;
      }

      try {
        this.dispatchPreviewLoading = true;
        const res = await fetch(`${request.gatewayBase}/dispatch/candidates`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({
            orderId: request.orderId,
            merchant: request.merchant,
            offerDetails: request.offerDetails,
          }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_candidate_preview_failed"
            )
          );
        }
        this.dispatchPreviewRequest = request;
        this.dispatchPreviewData = payload.preview || null;
        this.dispatchPreviewMode = mode === "retry" ? "retry" : "request";
        this.dispatchPreviewDialog = true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Candidate preview failed",
          text: error?.message || "Unable to load candidate riders.",
        });
      } finally {
        this.dispatchPreviewLoading = false;
      }
    },
    async confirmDispatchPreview() {
      const success =
        this.dispatchPreviewMode === "retry"
          ? await this.triggerDispatchRetry()
          : await this.triggerDispatch(this.dispatchPreviewRequest);
      if (success) {
        this.dispatchPreviewDialog = false;
      }
    },
    async triggerDispatchRetry() {
      const gatewayBase = this.getDispatchGatewayBase();
      const orderId = this.resolveDispatchOrderId();
      if (!gatewayBase || !orderId) {
        Swal.fire({
          icon: "error",
          title: "Retry unavailable",
          text: "Missing gateway or order information.",
        });
        return false;
      }

      try {
        this.dispatchLoading = true;
        const res = await fetch(`${gatewayBase}/dispatch/retry`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({ orderId }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_retry_failed"
            )
          );
        }
        this.applyOptimisticRetryState();
        Swal.fire({
          icon: "success",
          title: "Retry queued",
          text: `Order ${orderId} retry was sent to dispatch.`,
          timer: 1800,
          showConfirmButton: false,
        });
        return true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Retry failed",
          text: error?.message || "Unable to retry dispatch.",
        });
        return false;
      } finally {
        this.dispatchLoading = false;
      }
    },
    async triggerDispatch(preparedRequest = null) {
      let request = preparedRequest;
      if (!request) {
        try {
          request = await this.prepareDispatchRequest();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Dispatch data missing",
            text: error?.message || "Unable to prepare dispatch request.",
          });
          return false;
        }
      }

      try {
        this.dispatchLoading = true;
        const res = await fetch(`${request.gatewayBase}/dispatch/request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.getDispatchAuthorizationHeader(),
          },
          body: JSON.stringify({
            orderId: request.orderId,
            merchant: request.merchant,
            offerDetails: request.offerDetails,
          }),
        });
        const payload = await res.json().catch(() => ({}));
        if (!res.ok || payload?.ok === false) {
          throw new Error(
            this.getDispatchErrorMessage(
              payload?.error,
              "dispatch_request_failed"
            )
          );
        }
        Swal.fire({
          icon: "success",
          title: "Dispatch queued",
          text: `Order ${request.orderId} was sent to realtime dispatch.`,
          timer: 1800,
          showConfirmButton: false,
        });
        return true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "No Rider Accepted",
          text: error?.message || "Unable to queue dispatch request.",
        });
        return false;
      } finally {
        this.dispatchLoading = false;
      }
    },

    // Add today's special close date for the store in this order
    async addTodayStoreSpecialCloseDate() {
      if (
        !this.order_detail ||
        !this.order_detail.order_store ||
        !this.order_detail.order_store.length
      )
        return;

      // Confirm with the user before applying. Use global `$swal` if injected,
      // otherwise fallback to local `Swal` import.
      const swalInst = this.$swal || Swal;
      const confirmRes = await swalInst.fire({
        title: "ปิดร้านวันนี้",
        text: "คุณต้องการปิดร้านวันนี้หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่",
        cancelButtonText: "ยกเลิก",
      });
      if (!confirmRes || !confirmRes.isConfirmed) return;

      const store = this.order_detail.order_store[0];
      const today = new Date().toISOString().substr(0, 10);

      // Use same-day start and end (one-day close)
      const payload = {
        store_close_pattern_weekday: null,
        store_close_pattern_weeknum: null,
        store_close_type: "start_end",
        store_close_note: null,
        store_close_period: null,
        store_close_date_start: today,
        store_close_date_end: today,
        store_close_date: null,
        store_close_store_id: store.store_id,
        is_commit: false,
      };

      try {
        this.storeCloseLoading = true;
        const result = await this.$store.dispatch(
          "fetchStoreBack/addSpecialTime",
          payload
        );
        if (result !== false && result != null) {
          (this.$swal || Swal).fire({
            icon: "success",
            title: "Store special close date added",
          });
        } else if (result && result.message) {
          // Action returned an object with a message
          (this.$swal || Swal).fire({
            icon: "error",
            title: "Failed",
            text: result.message,
          });
        } else {
          (this.$swal || Swal).fire({
            icon: "error",
            title: "Failed to add special close date",
          });
        }
      } catch (e) {
        (this.$swal || Swal).fire({
          icon: "error",
          title: "Error",
          text: e.message,
        });
      } finally {
        this.storeCloseLoading = false;
      }
    },
    cloneOrder() {
      this.original_data = JSON.parse(JSON.stringify(this.order_detail));
    },
    unSavedData() {
      if (
        (JSON.stringify(this.original_data) !=
          JSON.stringify(this.order_detail) ||
          JSON.stringify(this.original_transfer_time) !=
            JSON.stringify(this.transfer_time) ||
          JSON.stringify(this.original_transfer_date) !=
            JSON.stringify(this.transfer_date) ||
          JSON.stringify(this.original_order_time) !=
            JSON.stringify(this.order_time) ||
          JSON.stringify(this.original_order_date) !=
            JSON.stringify(this.order_date) ||
          JSON.stringify(this.original_order_end_time) !=
            JSON.stringify(this.order_end_time) ||
          JSON.stringify(this.original_order_end_date) !=
            JSON.stringify(this.order_end_date)) &&
        this.loading == false
      ) {
        return false;
      } else {
        return true;
      }
    },
    toCancelOrder() {
      let isUnsavedData = !this.unSavedData();
      if (isUnsavedData == true) {
        alert("ข้อมูลมีการเปลี่ยนแปลง กรุณาอัพเดทก่อน");
      } else {
        this.cancelDialog = true;
        this.cancelRemark = "";
      }
    },
    async cancelOrder() {
      if (!this.$refs.formCancel.validate()) return;
      this.cancelDialog = false;
      this.canceling_order = true;
      let form = {
        order_id: this.order_detail.order_id,
        order_note:
          this.order_detail.order_note +
          " เหตุผลที่ยกเลิก: " +
          this.cancelRemark,
      };

      let check = await this.$store.dispatch("fetchOrderListBack/cancelOrder", {
        ...form,
        province: this.$route.params.province,
      });
      this.canceling_order = false;
      if (check == 2) {
        this.$emit("backListTable", "orderListTable");
        this.$emit("setPagename", true);
      }
    },
    setTime() {
      this.transfer_date = [];
      this.transfer_time = [];
      this.order_time = { value: { HH: "", mm: "" } };
      this.order_date = { value: null };
      this.order_end_time = { value: { HH: "", mm: "" } };
      this.order_end_date = { value: null };

      if (this.order_detail.order_time_start) {
        this.order_date.value = this.order_detail.order_time_start.substring(
          0,
          10
        );
        this.order_time.value = {
          HH: this.order_detail.order_time_start.substring(11, 13),
          mm: this.order_detail.order_time_start.substring(14, 16),
        };
      }
      this.original_order_time = JSON.parse(JSON.stringify(this.order_time));
      this.original_order_date = JSON.parse(JSON.stringify(this.order_date));
      if (this.order_detail.order_time_end) {
        this.order_end_date.value = this.order_detail.order_time_end.substring(
          0,
          10
        );
        this.order_end_time.value = {
          HH: this.order_detail.order_time_end.substring(11, 13),
          mm: this.order_detail.order_time_end.substring(14, 16),
        };
      }

      this.original_order_end_time = JSON.parse(
        JSON.stringify(this.order_end_time)
      );
      this.original_order_end_date = JSON.parse(
        JSON.stringify(this.order_end_date)
      );

      for (let info of this.order_detail.order_store) {
        if (info.store_order_time_end != null) {
          this.transfer_date.push({
            store_id: info.store_id,
            date: info.store_order_time_end.substring(0, 10),
          });
          this.transfer_time.push({
            HH: info.store_order_time_end.substring(11, 13),
            mm: info.store_order_time_end.substring(14, 16),
          });
        } else {
          this.transfer_date.push({ store_id: info.store_id, date: null });
          this.transfer_time.push({ HH: "", mm: "" });
        }
      }
      this.original_transfer_time = JSON.parse(
        JSON.stringify(this.transfer_time)
      );

      this.original_transfer_date = JSON.parse(
        JSON.stringify(this.transfer_date)
      );
    },
    async updateData() {
      for (let val of this.sub_district_list) {
        if (
          this.order_detail.order_customer_address
            .customer_address_sub_district_id == val.sub_district_id
        ) {
          this.order_detail.order_customer_address_zone =
            val.sub_district_name_th;
        }
      }
      this.update_loading = 1;
      if (
        this.order_date.value &&
        this.order_time.value.HH &&
        this.order_time.value.mm
      ) {
        this.order_detail.order_time_start =
          this.order_date.value +
          "T" +
          this.order_time.value.HH +
          ":" +
          this.order_time.value.mm +
          ":00";
      }
      if (
        this.order_end_date.value &&
        this.order_end_time.value.HH &&
        this.order_end_time.value.mm
      ) {
        this.order_detail.order_time_end =
          this.order_end_date.value +
          "T" +
          this.order_end_time.value.HH +
          ":" +
          this.order_end_time.value.mm +
          ":00";
      }
      for (let val of this.order_detail.order_store) {
        let index = this.order_detail.order_store.indexOf(val);
        if (
          this.transfer_date[index].date == null ||
          this.transfer_time[index].HH == "" ||
          this.transfer_time[index].mm == ""
        ) {
          val.store_order_time_end = null;
        } else {
          val.store_order_time_end =
            this.transfer_date[index].date +
            "T" +
            this.transfer_time[index].HH +
            ":" +
            this.transfer_time[index].mm +
            ":00";
        }
      }

      let form = {
        order_id: this.order_detail.order_id,
        order_type: this.order_detail.order_type,
        order_code: this.order_detail.order_code,
        order_customer_id: this.order_detail.order_customer_id,
        order_customer_full_name: this.order_detail.order_customer_full_name,
        order_customer_address_id: this.order_detail.order_customer_address_id,
        order_payment_type: this.order_detail.order_payment_type,
        order_is_paymented: this.order_detail.order_is_paymented,
        order_note: this.order_detail.order_note,
        order_status: this.order_detail.order_status,
        order_store: this.order_detail.order_store,
        order_transfer_note: this.order_detail.order_transfer_note,
        order_customer: this.order_detail.order_customer,
        order_customer_address: this.order_detail.order_customer_address,
        order_time_start: this.order_detail.order_time_start,
        order_time_end: this.order_detail.order_time_end,
      };
      this.update_loading = await this.$store.dispatch(
        "fetchOrderDetailBack/updateOrder",
        form
      );
      if (this.update_loading == 2) {
        this.setTime();
        this.original_data = JSON.parse(JSON.stringify(this.order_detail));
      }
      if (this.update_loading == 2 && this.order_detail.order_status == 6) {
        this.backToList();
      }
      this.getCountOrder();
    },
    async getNewDataList() {
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
    },
    async getCountOrder() {
      let check_res = await this.$store.dispatch(
        "fetchOrderListBack/getCountOrder"
      );
      if (JSON.stringify(check_res) != JSON.stringify(this.order_count_old)) {
        this.getNewDataList();
        this.$store.commit("fetchOrderListBack/getOldCountOrder", check_res);
      }
    },
    viewImage(data) {
      this.imageDialog = true;
      this.view_img_position = data.img;
      this.place_name = data.place_name;
    },
    backToList() {
      if (this.$route.params.orderid && this.$route.name == "OrderDetailFood") {
        this.$router.push({
          path:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/report/order_report",
        });
      } else {
        let isUnsavedData = !this.unSavedData();
        if (isUnsavedData == true) {
          confirm("คุณต้องการละทิ้งการเปลี่ยนแปลงหรือไม่ ? ") &&
            this.$emit("backListTable", "orderListTable");
        } else {
          this.getBack();
        }
      }
    },
    getBack() {
      this.$emit("backListTable", "orderListTable");
      this.$emit("setPagename", true);
    },
    async fetchAddress() {
      this.$store.dispatch("fetchProvinceBack/getProvinceList");
      this.$store.dispatch(
        "fetchProvinceBack/getDistrictList",
        this.order_detail.order_customer_address.customer_address_province_id
      );
      this.$store.dispatch(
        "fetchProvinceBack/getZipCodeList",
        this.order_detail.order_customer_address.customer_address_district_id
      );
      await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictList",
        this.order_detail.order_customer_address.customer_address_district_id
      );
    },
    async fetchData() {
      this.loading = true;
      let fetch_check = await this.$store.dispatch(
        "fetchOrderDetailBack/getOrderDetail",
        this.order_id
      );
      if (fetch_check != false) {
        this.$store.dispatch(
          "fetchCustomerBack/getCustomerAddressList",
          this.order_detail.order_customer_id
        );
        // await this.fetchAddress();
      }
      this.loading = false;
      // this.setTime();
    },
    async fetchDirectionRoute(storeLat, storeLng, customerLat, customerLng) {
      // Mapbox Directions API
      const accessToken =
        "pk.eyJ1IjoiYWxpY29ybnRlY2gxMjMiLCJhIjoiY21hMzd0M3l2MmFpajJrczd5cDFxZ3pnMSJ9.sz_Iu4K8W746uriOgMIT-w"; // Replace with your Mapbox token
      const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${storeLng},${storeLat};${customerLng},${customerLat}?geometries=polyline&access_token=${accessToken}`;
      try {
        const res = await fetch(url);
        const data = await res.json();
        if (data.routes && data.routes.length > 0) {
          // Decode polyline to array of lat/lng
          this.directionRoute = this.decodePolyline(data.routes[0].geometry);
        }
      } catch (e) {
        // Handle error
        this.directionRoute = [];
      }
    },
    // Polyline decoder (Google polyline algorithm)
    decodePolyline(str) {
      let index = 0,
        lat = 0,
        lng = 0,
        coordinates = [];
      while (index < str.length) {
        let b,
          shift = 0,
          result = 0;
        do {
          b = str.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += dlat;
        shift = 0;
        result = 0;
        do {
          b = str.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += dlng;
        coordinates.push({ latitude: lat / 1e5, longitude: lng / 1e5 });
      }
      return coordinates;
    },
    async prepareStoreAndCustomerPositions() {
      if (
        this.order_detail &&
        this.order_detail.order_store &&
        this.order_detail.order_customer_address
      ) {
        // Fallback to order_position if lat/lng not available
        let storeLat = "13.238988627138308",
          storeLng = "99.8217225956493";
        if (
          this.order_detail.order_position &&
          this.order_detail.order_position.length > 0
        ) {
          // Try to get from order_position
          const pos = this.order_detail.order_position[0];
          if (pos.position_lat && pos.position_long) {
            storeLat = parseFloat(pos.position_lat);
            storeLng = parseFloat(pos.position_long);
          }
        }
        // Customer address
        let customerLat = null,
          customerLng = null;
        if (
          this.order_detail.order_customer_address.customer_address_lat &&
          this.order_detail.order_customer_address.customer_address_long
        ) {
          customerLat = parseFloat(
            this.order_detail.order_customer_address.customer_address_lat
          );
          customerLng = parseFloat(
            this.order_detail.order_customer_address.customer_address_long
          );
        }
        if (storeLat && storeLng && customerLat && customerLng) {
          this.storePosition = { latitude: storeLat, longitude: storeLng };
          this.customerPosition = {
            latitude: customerLat,
            longitude: customerLng,
          };
          await this.fetchDirectionRoute(
            storeLat,
            storeLng,
            customerLat,
            customerLng
          );
        }
      }
    },
  },
  async created() {
    if (this.$route.params.orderid && this.$route.name == "OrderDetailFood") {
      this.$store.commit("fetchOrderListBack/setOrderStatusID", 6);
    }
    await this.fetchData();
    this.original_data = JSON.parse(JSON.stringify(this.order_detail)); // forUnsavedData

    await this.prepareStoreAndCustomerPositions();
    if (this.isAutoDispatchFeatureEnabled) {
      this.connectDispatchSocket();
      this.startDispatchStatusPolling();
    }
  },
  beforeDestroy() {
    this.disconnectDispatchSocket();
    this.stopDispatchStatusPolling();
  },
};
</script>

<style>
.order-section-card {
  background: rgba(255, 255, 255, 0.68) !important;
  border: 1px solid rgba(255, 255, 255, 0.82) !important;
  border-radius: 16px;
  box-shadow: 0 18px 52px rgba(27, 39, 51, 0.1) !important;
  overflow: hidden;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.food-actions-panel {
  background: rgba(244, 247, 248, 0.72) !important;
  border: 1px solid rgba(255, 255, 255, 0.84) !important;
  border-radius: 16px;
  box-shadow: 0 18px 52px rgba(27, 39, 51, 0.1) !important;
  margin: 12px 0;
  overflow: visible;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}
.food-actions-panel__body {
  align-items: center;
  display: flex;
  padding: 14px 16px;
}
.food-actions-panel__buttons {
  align-items: center;
  display: flex;
  flex: 1 1 520px;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
}
.food-action-btn {
  margin: 0 !important;
  min-height: 40px;
}
.food-action-btn--danger {
  margin-left: 4px !important;
}
.time-picker input.display-time {
  border: none;
}
.dispatch-timeline-toolbar-card {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.dispatch-timeline-heading {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}
.dispatch-timeline-toolbar-title {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.dispatch-retry-glass-btn {
  border: 1px solid rgba(255, 255, 255, 0.72) !important;
  box-shadow: 0 8px 18px rgba(253, 223, 0, 0.38) !important;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.order-action-surface .v-btn.primary {
  --glass-shadow-color: rgba(253, 223, 0, 0.38);
  --glass-shadow-hover-color: rgba(253, 223, 0, 0.5);
}
.order-action-surface .v-btn.red,
.order-action-surface .v-btn.error {
  --glass-shadow-color: rgba(244, 67, 54, 0.32);
  --glass-shadow-hover-color: rgba(244, 67, 54, 0.44);
}
.order-action-surface .v-btn.orange {
  --glass-shadow-color: rgba(255, 152, 0, 0.34);
  --glass-shadow-hover-color: rgba(255, 152, 0, 0.46);
}
.order-action-surface .v-btn.blue,
.order-action-surface .v-btn.info {
  --glass-shadow-color: rgba(33, 150, 243, 0.3);
  --glass-shadow-hover-color: rgba(33, 150, 243, 0.42);
}
.order-action-surface .v-btn.green,
.order-action-surface .v-btn.success {
  --glass-shadow-color: rgba(76, 175, 80, 0.3);
  --glass-shadow-hover-color: rgba(76, 175, 80, 0.42);
}
.order-action-surface .v-btn.grey {
  --glass-shadow-color: rgba(96, 125, 139, 0.24);
  --glass-shadow-hover-color: rgba(96, 125, 139, 0.34);
}
.order-action-surface
  .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(.v-btn--disabled) {
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 24px;
  box-shadow: 0 8px 18px var(--glass-shadow-color, rgba(38, 50, 56, 0.18)) !important;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.order-action-surface
  .v-btn:not(.v-btn--icon):not(.v-btn--floating):not(.v-btn--disabled):hover {
  box-shadow: 0 11px 24px
    var(--glass-shadow-hover-color, rgba(38, 50, 56, 0.24)) !important;
  transform: translateY(-1px);
}
.order-action-surface .v-btn--icon {
  border: 1px solid rgba(255, 255, 255, 0.38);
  box-shadow: 0 6px 14px var(--glass-shadow-color, rgba(38, 50, 56, 0.14)) !important;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.order-action-surface .v-btn.order-product-add-btn,
.order-action-surface .v-btn.order-product-add-btn:hover,
.order-action-surface .v-btn.order-product-add-btn:focus,
.order-action-surface .v-btn.order-product-add-btn:active {
  box-shadow: none !important;
  filter: none !important;
  outline: none !important;
  text-shadow: none !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.order-action-surface .v-btn.order-product-add-btn::before,
.order-action-surface .v-btn.order-product-add-btn::after {
  box-shadow: none !important;
  filter: none !important;
}
.dispatch-status-text {
  margin-top: 6px;
  color: #616161;
  font-size: 13px;
  font-weight: 600;
}
.dispatch-status-subtext {
  margin-top: 4px;
  color: #757575;
  font-size: 12px;
  line-height: 1.45;
}
.dispatch-timeline-horizontal {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-top: 12px;
  overflow-x: auto;
}
.dispatch-timeline-horizontal-item {
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
}
.dispatch-timeline-step {
  opacity: 0;
  transform: translateY(8px);
  animation: dispatch-timeline-reveal 420ms ease forwards;
  animation-delay: var(--dispatch-step-delay, 0ms);
}
.dispatch-timeline-step-active .v-icon {
  animation: dispatch-timeline-pulse 1.8s ease-in-out infinite;
  transform-origin: center;
}
.dispatch-timeline-horizontal-text {
  margin-left: 8px;
  font-weight: 500;
  white-space: nowrap;
}
.dispatch-timeline-horizontal-line {
  flex: 1 1 auto;
  min-width: 24px;
  height: 2px;
  margin: 0 12px;
  background-color: #e0e0e0;
}
.dispatch-timeline-vertical {
  margin-top: 8px;
}
.dispatch-timeline-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 6px 0 6px 4px;
}
.dispatch-timeline-text {
  margin-left: 8px;
  font-weight: 500;
}
.dispatch-timeline-line {
  position: absolute;
  left: 12px;
  top: 22px;
  height: 18px;
  width: 2px;
  background-color: #e0e0e0;
}
@keyframes dispatch-timeline-reveal {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dispatch-timeline-pulse {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0));
  }
  50% {
    transform: scale(1.12);
    filter: drop-shadow(0 0 6px rgba(253, 223, 0, 0.45));
  }
}
@media (max-width: 600px) {
  .food-actions-panel {
    border-radius: 14px;
    margin: 10px 0;
  }
  .food-actions-panel__body {
    padding: 16px;
  }
  .food-actions-panel__buttons {
    align-items: stretch;
    flex-basis: auto;
    flex-direction: column;
  }
  .food-action-btn,
  .food-actions-panel__buttons .v-btn {
    margin: 0 !important;
    width: 100%;
  }
  .food-action-btn--danger {
    margin-left: 0 !important;
  }
  .dispatch-timeline-heading {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
